"use client";

import type { ReactNode } from "react";
import clsx from "clsx";
import styles from "./section-backdrop.module.css";

type SectionBackdropTone = "schedule" | "rsvp" | "gifts" | "location";

type SectionBackdropProps = {
  tone: SectionBackdropTone;
  className?: string;
  contentClassName?: string;
  children: ReactNode;
};

export function SectionBackdrop({
  tone,
  className,
  contentClassName,
  children,
}: SectionBackdropProps) {
  return (
    <div className={clsx(styles.section, styles[tone], className)}>
      <div className={clsx(styles.content, contentClassName)}>{children}</div>
    </div>
  );
}
